import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      outerContainer: {
        padding: '0px 24px 24px 24px',
        minWidth: '100%'
      },
      deliveryInput: {
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        flexWrap: 'nowrap',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        borderRadius: '8px',
        justifyContent: 'center',
        height: '500px',
        [theme.breakpoints.down('lg')]: {
          height: '1385px'
        },
        [theme.breakpoints.only('lg')]: {
          height: 'auto'
        }
      },
      deliverySubHeading: {
        textAlign: 'center',
        fontSize: '30px',
        fontFamily: props.fontFamily,
        [theme.breakpoints.down('lg')]: {
          width: '612px',
          padding: '0px'
        }
      },
      deliveryInputBox: {
        width: '932px',
        background: 'transparent',
        margin: '12px 0px 100px 0px',
        [theme.breakpoints.down('lg')]: {
          width: '822px',
          margin: '16px 0px 64px 0px'
        }
      },
      deliveryInputBoxPhoneNumber: {
        width: '675px',
        background: 'transparent',
        margin: '10px 0px 10px 0px',
        [theme.breakpoints.down('lg')]: {
          margin: '16px 0px 64px 0px'
        }
      },
      selectionCardContainer: {
        justifyContent: 'space-around',
        background: 'transparent',
        marginBottom: '20px',
        [theme.breakpoints.down('lg')]: {
          gap: '25px',
          paddingTop: '25px',
          minHeight: '1300px',
          alignItems: 'center'
        }
      }
    })
  );
